import React from 'react';
import MemberCard from './MemberCard';
import MAvatar from '@/components/ui/atoms/MAvatar';
import { IconLogout, IconUserStar, IconUserX, IconEdit } from '@tabler/icons-react';
import MOptionsMenu from '@/components/ui/atoms/MOptionsMenu';

import { useEffect, useState } from 'react';
import { membersService } from '@/services/members.service';
import { memberNormalizer } from '@/utils/memberNormalizer';

const FamilyAccessSplit = ({ members = [], managedIds, loggedInMember, handleExitFamilyDialog, handleDeleteProfileDialog, handleEditNickname }) => {
  const [managedMembers, setManagedMembers] = useState<any[]>([]);
  useEffect(() => {
    if (loggedInMember?.family_member_type === 'fm') {
      membersService.getManagedMembers().then(setManagedMembers);
    }
  }, [loggedInMember]);

  if (!Array.isArray(members) || !loggedInMember) return null;
  // Sort: logged-in member first, then owner, then others
  const sortedMembers = [...members].sort((a, b) => {
    if (a.id === loggedInMember.id) return -1;
    if (b.id === loggedInMember.id) return 1;
    if (a.family_member_type === 'fo') return -1;
    if (b.family_member_type === 'fo') return 1;
    return 0;
  });
  // For FM, always include self in 'Profiles you can access'
  let canAccess: any[] = [];
  let cannotAccess: any[] = [];
  if (loggedInMember.family_member_type === 'fm') {
    canAccess = sortedMembers.filter(m => m.id === loggedInMember.id || managedMembers.some(mm => mm.id === m.id));
    cannotAccess = sortedMembers.filter(m => m.id !== loggedInMember.id && !managedMembers.some(mm => mm.id === m.id));
  } else {
    if (managedIds == null) return null;
    const safeManagedIds = Array.isArray(managedIds) ? managedIds : [];
    canAccess = sortedMembers.filter(m => m.id === loggedInMember.id || safeManagedIds.includes(m.id));
    cannotAccess = sortedMembers.filter(m => m.id !== loggedInMember.id && !safeManagedIds.includes(m.id));
  }
  const renderMemberCard = (memberObj: any, hideViewProfileLink: boolean, canEditNickname: boolean) => {
    const member = memberNormalizer(memberObj); 
    let menu = null;
    // Show Edit Nickname for other profiles you can access (not self, not for profiles you can't access)
    if (canEditNickname) {
      menu = [
        {
          id: 'edit-nickname',
          label: 'Edit Nickname',
          icon: <IconEdit size={16} />, // Use a suitable icon
          onClick: () => handleEditNickname(member),
        }
      ];
    } else if (member.id === loggedInMember.id) {
      menu = [
        {
          id: 'exit',
          label: 'Leave Family',
          icon: <IconLogout size={16} />, // Use a suitable icon
          onClick: () => handleExitFamilyDialog(member),
        },
        {
          id: 'delete-profile',
          label: 'Delete Account',
          icon: <IconUserX size={16} color="#983145" />, // Use a suitable icon
          onClick: () => handleDeleteProfileDialog(member),
          className: 'text-red-600',
        }
      ];
    }
    return (
      <MemberCard
        key={member.id}
        avatar={<MAvatar size="md" type={member?.avatar ? 'dp' : 'no-dp'} src={member?.avatar} text={`${member?.firstName || ''}${member?.lastName ? ' ' + member.lastName : ''}`.trim()} showBadge={member.family_member_type === 'fo'} badgeIcon={member.family_member_type === 'fo' ? <IconUserStar size={8} /> : undefined} />}
        name={member.nickname || (member.firstName) }
        isOwner={member.family_member_type === 'fo'}
        relationship={member.id === loggedInMember.id ? 'You' : member.relationship}
        registered={member.registered_member}
        invited={member.registration_status === 'invited'}
        showRegistrationLabels={true}
        member_type={member.memberType}
        dob_year={member.dobYear}
        dob_month={member.dobMonth}
        dob_day={member.dobDay}
        loggedInMember={member.id === loggedInMember.id}
        member={member}
        hideViewProfileLink={hideViewProfileLink}
        menu={menu && menu.length > 0 ? <MOptionsMenu options={menu} /> : undefined}
      />
    );
  };
  return (
    <div className="flex flex-col gap-3 mt-[24px]">
      {/* Profiles you can access */}
      <div className="body-base-bold" style={{ color: '#AD95D1', marginTop: 16 }}>
        Profiles you can access
      </div>
      {[...canAccess].sort((a, b) => (a.id === loggedInMember.id ? -1 : b.id === loggedInMember.id ? 1 : 0)).map(member => renderMemberCard(member, false, member.id !== loggedInMember.id))}
      {/* Profiles you can't access */}
      <div className="body-base-bold" style={{ color: '#AD95D1', marginTop: 16 }}>
        Profiles you can't access
      </div>
      {cannotAccess.map(member => renderMemberCard(member, true, false))}
    </div>
  );
};

export default FamilyAccessSplit;
